export const GOOGLE_AUTH_LINK = `${process.env.REACT_APP_SERVER_URL}auth/google`;